import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import GlobalContextWrapper from '../components/global-context-wrapper/global-context-wrapper';
import MakerHero from '../components/maker-hero/maker-hero';
import MakerWhyVibecity from '../components/maker-why-vibecity/maker-why-vibecity';
import MakerSellingCategories from '../components/maker-selling-categories/maker-selling-categories';
import MakerVibecityTools from '../components/maker-vibecity-tools/maker-vibecity-tools';
import MakerVibecityPricing from '../components/maker-vibecity-pricing/maker-vibecity-pricing';
import MakerVcCommunity from '../components/maker-vc-community/maker-vc-community';
import MakerFAQ from '../components/maker-faq/maker-faq';
import MakerMeetSeller from '../components/maker-meet-seller/maker-meet-seller';
import MakerAboutVc from '../components/maker-about-vc/maker-about-vc';
import { DesktopFooter } from '@vc-workspace/desktop-footer';
import { MobileFooter } from '@vc-workspace/mobile-footer';
import { useEffect } from 'react';
import { AmplitudeEventNames, sendAmplitudeData } from '@vc-workspace/utils-amplitude';
import { PageTypes } from '@vc-workspace/utils-constants';
import MakerFloatingCta from '../components/maker-floating-cta/maker-floating-cta';
import BasicSEO from '../components/seo/BasicSEO';

var Maker = function Maker(props) {
  useEffect(function () {
    sendAmplitudeData(AmplitudeEventNames.PAGE_VIEWED, {
      page_type: PageTypes.MAKER
    });
  }, []);
  return /*#__PURE__*/_jsxs(GlobalContextWrapper, {
    context: props.context,
    hideCategoriesList: true,
    attributionData: {
      allowed: false,
      query: props.context.query,
      page_type: PageTypes.MAKER,
      page_id: 'maker-homepage'
    },
    hideNavbar: !!props.context.query['withoutHeader'],
    disableNavActions: true,
    children: [/*#__PURE__*/_jsx(BasicSEO, {
      title: "Vibecity Seller"
    }), /*#__PURE__*/_jsx(MakerHero, {
      context: props.context
    }), /*#__PURE__*/_jsx(MakerWhyVibecity, {
      context: props.context
    }), /*#__PURE__*/_jsx(MakerSellingCategories, {
      context: props.context
    }), /*#__PURE__*/_jsx(MakerVibecityTools, {
      context: props.context
    }), /*#__PURE__*/_jsx(MakerVibecityPricing, {
      context: props.context
    }), /*#__PURE__*/_jsx(MakerVcCommunity, {
      context: props.context
    }), /*#__PURE__*/_jsx(MakerFAQ, {
      context: props.context
    }), /*#__PURE__*/_jsx(MakerMeetSeller, {
      context: props.context
    }), /*#__PURE__*/_jsx(MakerAboutVc, {
      context: props.context
    }), props.context.isMobileView ? /*#__PURE__*/_jsx(MobileFooter, {
      ignoreDefaultMargin: true
    }) : /*#__PURE__*/_jsx(DesktopFooter, {
      ignoreDefaultMargin: true
    }), props.context.isMobileView ? /*#__PURE__*/_jsx(MakerFloatingCta, {}) : null]
  });
};

export var __N_SSP = true;
export default Maker;